import { AppSchema } from '/common/types'
import { getAssetUrl } from '/web/shared/util'
import { JSX } from 'solid-js'
import { A } from '@solidjs/router'
import { getModelUrl } from '/web/shared/aifans/lib/model-util'

const BADGES: Record<number, { label: string; class: string } | undefined> = {}

const getBadge = (index: number) => {
  const badges = [
    { label: '🔥 Hot', bg: 'linear-gradient(135deg, #8A2BE2, #FF3CAC)' },
    { label: '⚡ New', bg: 'linear-gradient(135deg, #8A2BE2, #00E5FF)', color: '#001218' },
    { label: 'VIP', bg: 'linear-gradient(135deg, #2dc653, #0d8c3a)' },
    { label: '⭐ Top', bg: 'linear-gradient(135deg, #FFD23F, #FF9800)', color: '#1a1000' },
  ]
  return badges[index % badges.length]
}

export default function PopularCreators(props: {
  creators: AppSchema.Character[]
  title: JSX.Element
}) {
  const link = (creator: AppSchema.Character) =>
    getModelUrl(creator.categorySlug, creator.slug || creator._id)

  return (
    <section class="cf-section">
      {props.title}

      <div class="mt-4 grid gap-3 grid-cols-2 sm:gap-4 lg:grid-cols-4">
        {props.creators.map((creator, i) => {
          const badge = getBadge(i)
          return (
            <A
              href={link(creator)}
              class="cf-creator-card group"
            >
              {/* Image */}
              <div class="relative overflow-hidden" style={{ 'aspect-ratio': '3/4' }}>
                {creator.avatar && (
                  <img
                    class="h-full w-full object-cover object-top transition-transform duration-[400ms] group-hover:scale-105"
                    src={getAssetUrl(`${creator.avatar}`, true, { width: 762 })}
                    alt={`${creator.realName} cosplays as ${creator.name}`}
                    loading="lazy"
                  />
                )}
                {/* Badge */}
                <div
                  class="absolute left-2.5 top-2.5 z-[2] rounded-md px-2.5 py-1 font-rajdhani text-[10px] font-extrabold uppercase tracking-[1px] text-white"
                  style={{
                    background: badge.bg,
                    color: badge.color || '#fff',
                  }}
                >
                  {badge.label}
                </div>
              </div>

              {/* Meta */}
              <div class="px-3.5 pb-3.5 pt-3">
                {/* Category / Real name */}
                <div class="mb-1 font-rajdhani text-[10px] font-bold uppercase tracking-[1.5px] text-[var(--cf-cyan)]">
                  {creator.realName || 'Creator'}
                </div>
                {/* Character name */}
                <div class="mb-1.5 font-bebas text-[18px] leading-tight tracking-[1px] text-white">
                  {creator.name}
                </div>
                {/* Stats */}
                <div class="flex items-center gap-3 font-rajdhani text-[12px] text-[var(--cf-muted)]">
                  <span class="font-bold text-[#ffc107]">★ {(4.5 + Math.random() * 0.5).toFixed(1)}</span>
                  <span>{(Math.floor(Math.random() * 90) + 10).toFixed(1)}K fans</span>
                </div>
              </div>
            </A>
          )
        })}
      </div>
    </section>
  )
}
